import { defineFcm } from '../shared/factory';

export const FCM_MEMBERSHIP_CONTACT_EMAIL = defineFcm('membership_contact_email')
	.asString()
	.withDefault('help@change.org')
	.toConfig();
